import Navbar from "@/components/Navbar";
import Marquee from "@/components/Marquee";
import ServiceGrid from "@/components/ServiceGrid";
import FullBleed from "@/components/FullBleed";
import ReviewsSection from "@/components/ReviewsSection";
import FAQ from "@/components/FAQ";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import { PHONE, PHONE_LINK, WA_LINK } from "@/constants/site";

const Home = () => (
  <div className="bg-[#110e1a] text-[#f8fafc] min-h-screen antialiased overflow-x-hidden">
    <Navbar />

    {/* Set-Piece Hero */}
    <section className="pt-16 pb-24 px-6 border-b border-white/5 relative overflow-hidden" data-testid="hero-section">
      <div className="max-w-6xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-pink-500/10 border border-pink-500/30 text-pink-400 text-xs font-mono uppercase tracking-widest mb-6">
          <span>Non-Stop Production &bull; 24/7 Live</span>
        </div>
        <h1 className="font-poster text-5xl sm:text-7xl lg:text-8xl tracking-normal uppercase leading-[0.92] text-white mb-6 text-balance">
          <span className="ln"><span>Fast Turnaround on Software</span></span>
          <span className="ln">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-400 via-fuchsia-300 to-indigo-400">
              and Academic Proposals
            </span>
          </span>
        </h1>
        <p className="fade-sub text-base sm:text-lg text-slate-300 max-w-2xl mx-auto leading-relaxed mb-10">
          One place for tech and academic help with 24/7 day and night availability.
        </p>

        <div className="fade-sub flex flex-wrap justify-center items-center gap-4">
          <a
            href="#contact"
            data-testid="hero-order-btn"
            className="px-8 py-4 rounded-xl bg-pink-500 hover:bg-pink-600 text-white font-bold text-sm tracking-wide transition-colors shadow-xl shadow-pink-500/30"
          >
            Order Project Online &rarr;
          </a>
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-whatsapp-btn"
            className="px-6 py-4 rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 text-white font-medium text-sm transition-colors"
          >
            WhatsApp: {PHONE}
          </a>
          <a
            href={PHONE_LINK}
            data-testid="hero-call-btn"
            className="px-6 py-4 rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 text-slate-300 hover:text-white text-sm transition-colors"
          >
            Call Helpline Now
          </a>
        </div>
      </div>
    </section>

    <Marquee />
    <ServiceGrid />
    <FullBleed />
    <ReviewsSection />
    <FAQ />
    <ContactSection />
    <Footer />
    <WhatsAppFloat />
  </div>
);

export default Home;
